
import React from 'react'
import Avatars from './Avatar Template/Avatar'
import Buttons from './ButtonTemplates/Button'
import Progress from './ProgressBar Template/Progress'
import SampleView from './SampleTemplates/SampleView/SampleView'
import Steppers from './Stepper Template/Steppers'
import Timelines from './Timeline Template/Timeline'
import Calender from './calendar Template/Calendar'
import Sample from './sample'
import { BrowserRouter as Router, Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import Home from './Home'
import CommonDashboard from '../CommonDashboard'
import TenantProvisioning from '../components/tenant-webapp/TenantProvisioningPage'
import TenantUserSetup from '../components/userSetUp/TenantUserSetup'
import Tenant from '../components/tenant-webapp/tenantList/Tenant'
import TradeQuestions from '../components/questionBuilder/TradeQuestions'
import Questions from '../components/questionBuilder/components/Questions'
import AddCategory from '../components/AddCategory'
import CategoryMasterList from '../components/CategoryMasterList'
import Master from '../components/ProductMaster'
import Tradeconfiguration from '../components/trade/TradeList'
import Featuresconfiguration from '../components/questionBuilder/Features'
import ThirdPartyConfiguration from './Configuration/Configuration'
import Subscription from '../components/subscription/Subscription'
import Naomi from './Naomi'
import TradeTemplates from './TradeTemplates'
import TemplateList from '../communications/TemplateList'
import TemplateEditor from '../communications/TemplateEditor'
import ReviewDetail from '../communications/ReviewDetail'
import AutomationPlansPage from '../automation/AutomationPlansPage'

const PageRoutes = () => {
  return (
    <div>
      <ReactRoutes>
        <Route path='/' element={<Home />} />
        <Route path="/calender" element={<Calender />} />
        <Route path="/sample" element={<Sample />} />
        <Route path="/sampleview" element={<SampleView />} />
        <Route path="/button" element={<Buttons />} />
        <Route path="/progress" element={<Progress />} />
        <Route path="/timeline" element={<Timelines />} />
        <Route path="/avatar" element={<Avatars />} />
        <Route path="/stepper" element={<Steppers />} />
        <Route path="/calender" element={<Calender />} />
        <Route path="/commondashboard" element={<CommonDashboard />} />
        <Route path="/tenantuser" element={<TenantUserSetup />} />
        <Route path="/tenant" element={<Tenant />} />
        <Route path="/tenantprovision" element={<TenantProvisioning />} />
        <Route path="/tradeconfiguration" element={<TradeQuestions />} />
        <Route path="/assettemplate" element={<Questions questionType='asset' tradeTypeName='asset' />} />
        <Route path="/categorymaster" element={<CategoryMasterList />} />
        <Route path="/master" element={<Master />} />
        <Route path="/tradelist" element={<Tradeconfiguration />} />
        <Route path="/features" element={<Featuresconfiguration />} />
        <Route path="/configuration" element={<ThirdPartyConfiguration />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/naomi" element={<Naomi />} />
        <Route path="/trade-templates" element={<TradeTemplates />} />
        {/* Communication Management §9 — provider-admin template screens (authenticated-only, server-side).
            Review Detail takes uid + version because a template's identity is (templateMasterUid,
            version), never the uid alone. */}
        <Route path="/communications/templates" element={<TemplateList />} />
        <Route path="/communications/templates/new" element={<TemplateEditor />} />
        {/* The standalone review-queue page was removed — the queue now lives only as the
            "Template Review" tab inside Message Templates (/communications/templates). The old
            top-level URL redirects there so any stale bookmark still lands on the tab; only the
            review DETAIL route remains, opened by that tab's "Review" button. */}
        <Route
          path="/communications/review"
          element={<Navigate to="/communications/templates" state={{ tab: 'review' }} replace />}
        />
        <Route path="/communications/review/:uid/:version" element={<ReviewDetail />} />
        {/* Automation Plans — provider authoring of plan masters/versions/steps. Authoring is now a
            modal opened from the list (PlanMasterBuilder), so there is no separate editor route. */}
        <Route path="/automation/plans" element={<AutomationPlansPage />} />
      </ReactRoutes>
    </div>
  )
}

export default PageRoutes;
